import React, { useState } from 'react';
import { Box, IconButton, Typography, Collapse, Button } from '@mui/material';
import { ExpandMore, ExpandLess, Download } from '@mui/icons-material';
import InlineDataTable from './InlineDataTable';

const CollapsibleTable = ({ columns, rows, title, defaultExpanded = false, sparklines }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const exportToCSV = (e) => {
    e.stopPropagation(); // Prevent collapse/expand when clicking export
    
    // Create CSV content
    const csvRows = [];
    csvRows.push(columns.join(','));
    
    rows.forEach(row => {
      const csvRow = row.map(cell => {
        const cellStr = String(cell);
        if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
          return `"${cellStr.replace(/"/g, '""')}"`;
        }
        return cellStr;
      });
      csvRows.push(csvRow.join(','));
    });
    
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${title || 'data'}_export_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          cursor: 'pointer',
          p: 1,
          backgroundColor: 'rgba(71, 189, 198, 0.08)',
          borderRadius: 1,
          '&:hover': {
            backgroundColor: 'rgba(71, 189, 198, 0.15)'
          }
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <IconButton size="small" sx={{ mr: 1 }}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, flex: 1 }}>
          {title || 'Detailed Results'} ({rows.length} rows)
        </Typography>
        <Button
          size="small"
          startIcon={<Download />}
          onClick={exportToCSV}
          sx={{
            textTransform: 'none',
            fontSize: '0.7rem',
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'rgba(71, 189, 198, 0.2)'
            }
          }}
        >
          CSV
        </Button>
      </Box>
      
      <Collapse in={expanded}>
        <Box sx={{ mt: 1 }}>
          <InlineDataTable 
            columns={columns}
            rows={rows}
            showExport={false}
            sparklines={sparklines}
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleTable;

